/*
 * UserList Messages
 *
 * This contains all the text for the UserList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  routeSchedule: {
    id: 'app.components.RouteSchedule.routeSchedule',
    defaultMessage: 'Schedule',
  },
  from: {
    id: 'app.components.RouteSchedule.from',
    defaultMessage: 'From',
  },
  until: {
    id: 'app.components.RouteSchedule.until',
    defaultMessage: 'Until',
  },
  saveSuccess: {
    id: 'app.components.RouteSchedule.saveSuccess',
    defaultMessage: 'Route schedules saved',
  },
  save: {
    id: 'app.components.RouteSchedule.save',
    defaultMessage: 'Save route schedules',
  },
  addOpeningHours: {
    id: 'app.components.RouteSchedule.addOpeningHours',
    defaultMessage: 'Add opening hours',
  },
  removeOpeningHours: {
    id: 'app.components.RouteSchedule.removeOpeningHours',
    defaultMessage: 'Remove opening hours',
  },
  noOpeningHoursForThisDay: {
    id: 'app.components.RouteSchedule.noOpeningHoursForThisDay',
    defaultMessage: 'No opening hours on this day',
  },
  featureDescription: {
    id: 'app.components.RouteSchedule.featureDescription',
    defaultMessage: 'Feature description',
  },
});
